import { extend } from 'sk-ui/lib/utils/util.js'

import { action } from 'sky-engine/api'

import collectSoftwareDetailForm from './metaData/collectSoftwareDetailForm'
import compatible from './metaData/compatible'
import relateTestCase from './metaData/relateTestCase'
import softwareDetailForm from './metaData/softwareDetailForm'
import softwareForm from './metaData/softwareForm'

import { PROJECT_COLLECT_REPORT } from '@/api'

export default {
  SoftwareCreate({ commit }, params) {
    const props = {}
    this.dispatch('OpenFullDialog', {
      metaData: softwareForm,
      props
    })
  },
  SoftwareEdit({ commit }, params) {
    const props = {
      title: '编辑软件',
      params: {
        id: params.rowIds[0]
      }
    }
    const editForm = extend(true, {}, softwareForm)
    this.dispatch('OpenFullDialog', { metaData: editForm, props, clone: false })
  },
  ShowSoftwareRelationDetail({ commit }, params) {
    var props = {
      params: {
        id: params.softwareId
      }
    }
    this.dispatch('OpenDrawerDetailRelation', {
      metaData: softwareDetailForm,
      props,
      drawerProps: {
        title: '【' + params.softwareName + '】详情',
        class: 'wsp-case-relation-drawer-45'
      }
    })
  },
  ShowSoftwareDetail({ commit }, params) {
    var props = {
      params: {
        id: params.id
      }
    }
    this.dispatch('OpenDrawerDetailRelation', {
      metaData: softwareDetailForm,
      props,
      drawerProps: {
        title: '【' + params.softwareName + '】详情',
        class: 'wsp-case-relation-drawer-45'
      }
    })
  },
  ShowCollectSoftwareDetail({ commit }, params) {
    var props = {
      params: {
        id: params.id
      }
    }
    this.dispatch('OpenDrawerDetailRelation', {
      metaData: collectSoftwareDetailForm,
      props,
      drawerProps: {
        title: '【' + params.softwareName + '】详情',
        class: 'wsp-case-relation-drawer-45'
      }
    })
  },
  SoftwareCompatibleProductRelationByName({ commit }, params) {
    const props = {
      params: {
        name: params.softwareName
      }
    }
    const compatibleCopy = extend(true, {}, compatible)
    this.dispatch('OpenDetailDialog', { metaData: compatibleCopy, props, clone: false })
  },
  SoftwareCompatibleProductRelationById({ commit }, params) {
    const props = {
      params: {
        softwareId: params.softwareId
      }
    }
    const compatibleCopy = extend(true, {}, compatible)
    this.dispatch('OpenDetailDialog', { metaData: compatibleCopy, props, clone: false })
  },
  SoftwareCompatibleProductRelation({ commit }, params) {
    const props = {
      params: {
        softwareId: params.row.id
      }
    }
    const compatibleCopy = extend(true, {}, compatible)
    this.dispatch('OpenFullDialog', { metaData: compatibleCopy, props, clone: false })
  },
  softwareRelateTestCase({ commit }, params) {
    const props = {
      params: {
        id: params.rowIds[0]
      },
      extraParams: {
        softwareId: params.rowIds[0]
      }
    }
    this.dispatch('OpenFullDialog', {
      metaData: relateTestCase,
      props
    })
  },
  softwareRelationTestCase({ commit }, props) {
    import('../caseSoftwareMng/metaData/caseSoftware').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData)
      metaDataCopy.default.view.columns.unshift({
        props: {
          type: 'selection',
          width: 55
        }
      })
      metaDataCopy.default.view.menus = []
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props })
    })
  },
  syncYunZhiSoftware({ commit }, props) {
    props.viewController.loading = true
    const req = {
      model: 'Soft'
    }
    action(PROJECT_COLLECT_REPORT, 'syncCompatFromYunZhi', req)
      .then(response => {
        props.viewController.loading = false
        this.dispatch('OpenNotification', { message: '软件兼容性同步成功', type: 'success' })
      })
      .catch(e => {
        props.viewController.loading = false
        throw e
      })
  }
}
